import * as z from 'zod';

import { BorrowerId, CompanyId, LoanId, UserId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

// deprecated for CreateLoanNoteEvent
export const AddAccountCommentEvent = BaseLoanEvent.extend({
  type: z.literal('addAccountComment'),
  companyId: CompanyId,
  loanId: LoanId,
  comment: z.string(),
  borrowerId: BorrowerId.optional(),
  userId: UserId,
});
export type AddAccountCommentEvent = z.infer<typeof AddAccountCommentEvent>;
